import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

import { handleBlurInput } from '@/utils'
import { translate } from '@/languages/i18n'
import HashTag from '@/components/hash-tag/index.vue'
import { PropType, ref, onMounted, watch } from 'vue'
import { REGEX_EMOJI } from '@/constants/regex'
import commonService from '@/services/common.service'
import {
  VALIDATOR_CONTAIN_NG_WORD,
  VALIDATOR_EMOJI,
  VALIDATOR_DUPLICATE_TAG,
  ARTICLE_TAG_LIMIT,
  VALIDATE_TAG_LIMIT,
  ArticleCreateMode,
} from '@/views/community-admin/community-site/constants'
import { uniqBy } from 'lodash'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { ArticleTag } from '@/store/modules-community-admin/community-site'

type TAG = { id: number; name: string }


export default /*#__PURE__*/_defineComponent({
  props: {
  originalTags: {
    type: Array as PropType<Array<ArticleTag>>,
  },
  mode: {
    type: String as PropType<ArticleCreateMode | null>,
    default: ArticleCreateMode.CREATE,
  },
},
  setup(__props, { expose }) {

const props = __props



const inputRef = ref<HTMLInputElement>(null)
const tagModel = ref<string>('')
const error = ref<string>('')
const isValidating = ref<boolean>(false)
const tags = ref<Array<string>>([])
const removedTags = ref<Array<string>>([])

onMounted(() => {
  tags.value = props.originalTags?.filter((tag) => !tag['_destroy']) ?? []
  removedTags.value = props.originalTags?.filter((tag) => tag['_destroy']) ?? []
})

watch(
  () => tags.value,
  () => {
    if (tags.value.length > ARTICLE_TAG_LIMIT) {
      error.value = VALIDATE_TAG_LIMIT
    } else if (uniqBy(tags.value, 'name').length !== tags.value.length) {
      error.value = VALIDATOR_DUPLICATE_TAG
    } else {
      error.value = ''
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => tagModel.value,
  () => {
    if (error.value === VALIDATOR_CONTAIN_NG_WORD || error.value === VALIDATOR_EMOJI) {
      error.value = ''
      validateAllTags()
    }
  }
)
const validateTagContent = async (content: string) => {
  isValidating.value = true
  const emojiCheck = REGEX_EMOJI.test(content)
  if (!emojiCheck) {
    error.value = VALIDATOR_EMOJI
  }
  isValidating.value = false
}

const validateInputAndCreateTag = async () => {
  if (!tagModel.value || tags.value.length === ARTICLE_TAG_LIMIT) return

  try {
    await validateTagContent(tagModel.value)

    if (!error.value || error.value === VALIDATOR_DUPLICATE_TAG) {
      const trimmedArray = tagModel.value.replace(/\s+/g, ' ').split(' ')
      trimmedArray.forEach((elem: string) => {
        for (let i = 0; i < elem.length; i = i + 20) {
          if (tags.value?.length === ARTICLE_TAG_LIMIT) break
          let trimmedString = elem.substring(i, i + 20)
          tags.value = [
            ...tags.value,
            {
              id: `new-${Date.now()}${tags.value?.length}`,
              name: trimmedString,
            },
          ]
        }
      })

      tagModel.value = ''
      if (tags.value?.length < ARTICLE_TAG_LIMIT) {
        inputRef.value?.focus()
      }
    }
  } catch (error) {
    isValidating.value = false
  }
}

const removeTag = async (index: number): Promise<void> => {
  const deletedTag = tags.value[index]
  if (!deletedTag.id.includes('new-')) {
    removedTags.value = [...removedTags.value, deletedTag]
  }
  tags.value = tags.value.filter((_, i) => i !== index)
  await validateAllTags()
}

const editTag = async (id: number, name: string): Promise<void> => {
  const trimmedArray = name.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string, index: number) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if ((index || (!index && i)) && tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      if (!index && !i) {
        tags.value = tags.value.map((e: TAG) => ({
          ...e,
          name: e.id === id ? trimmedString : e.name,
        }))
      } else {
        tags.value.push({
          id: `new-${Date.now()}${tags.value?.length}`,
          name: trimmedString,
        })
      }
    }
  })
  await validateAllTags()
}

const validateAllTags = async () => {
  if (tags.value.length === 0) {
    return
  }
  const tagData = tags.value.map((e: TAG) => e.name).join(', ')
  await validateTagContent(tagData)
}

const getAllTagContent: Promise<Array<ArticleTag> | null> = async () => {
  await validateAllTags()
  if (error.value) {
    return null
  }
  if (props.mode === ArticleCreateMode.CREATE) {
    return {
      tags: tags.value,
    }
  } else {
    return {
      tags: tags.value,
      removedTags: removedTags.value,
    }
  }
}

const updateTags = (tagList: Array<ArticleTag>) => {
  tags.value = tagList?.filter((tag) => !tag['_destroy']) ?? []
  removedTags.value = tagList?.filter((tag) => tag['_destroy']) ?? []
}

expose({
  getAllTagContent: () => getAllTagContent(),
  updateTags,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      class: _normalizeClass(["d-flex flex-wrap form-control", error.value ? 'is-invalid' : '']),
      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.focusInputTag && _ctx.focusInputTag(...args)), ["self"]))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
        return (_openBlock(), _createBlock(HashTag, {
          tag: tag,
          key: tag.id,
          class: "me-2 mb-2",
          "wide-text-input": "",
          removeTag: () => removeTag(index),
          onEditTag: editTag,
          editable: true
        }, null, 8, ["tag", "removeTag"]))
      }), 128)),
      (tags.value.length < _unref(ARTICLE_TAG_LIMIT))
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            ref: (_value, _refs) => {
              _refs['inputRef'] = _value
              inputRef.value = _value
            },
            type: "text",
            class: "border-0 input-tag",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tagModel).value = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($event.target.blur()), ["enter"])),
            onInput: _cache[2] || (_cache[2] = (eve) => _unref(handleBlurInput)(eve, inputRef.value)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (validateInputAndCreateTag()))
          }, null, 544)), [
            [
              _vModelText,
              tagModel.value,
              void 0,
              { trim: true }
            ]
          ])
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(InputErrorMessage, {
      title: '',
      validator: error.value
    }, null, 8, ["validator"])
  ]))
}
}

})